import { ComponentConfig } from "@measured/puck";
import { spacingOptions } from "@/puck/options";

import styles from "./styles.module.css";
import getClassNameFactory from "@/lib/get-class-name-factory";

const getClassName = getClassNameFactory("Space", styles);

export type SpaceProps = {
  direction?: "both" | "vertical" | "horizontal";
  size: string;
};

export const Space: ComponentConfig<SpaceProps> = {
  label: "Space",
  fields: {
    size: {
      type: "select",
      options: spacingOptions,
    },
    direction: {
      type: "radio",
      options: [
        { value: "vertical", label: "Vertical" },
        { value: "horizontal", label: "Horizontal" },
        { value: "both", label: "Both" },
      ],
    },
  },
  defaultProps: {
    direction: "vertical",
    size: "24px",
  },
  inline: true,
  render: ({ direction, size, puck }) => {
    return (
      <div
        ref={puck.dragRef}
        className={getClassName(direction ? { [direction]: direction } : {})}
        style={{ "--size": size } as any}
      />
    );
  },
};
